module.exports = __webpack_public_path__ + "img/img-2.ae5ff9da.png";